import { useIsSystemDarkMode } from "@hooks/use-system-theme-mode";
import { useThemeMode } from "@hooks/use-theme-mode";

/** @returns whether the app is shown in the dark colour scheme, "system" resolved against the OS */
export function useIsDarkMode(): boolean {
  const themeMode = useThemeMode();
  const isSystemDark = useIsSystemDarkMode();

  return themeMode === "system" ? isSystemDark : themeMode === "dark";
}
